<template>
  <el-table-column label="編集">
    <template #default="{ row }">
      <el-row :min-width="200">
        <el-col>
          <el-button
            type="warning"
            size="small"
            v-if="isEdit(row.uid)"
            @click="editCanceled(row.uid)"
            >Cancel</el-button
          >
          <el-button
            type="success"
            :icon="Upload"
            size="small"
            v-if="isEdit(row.uid)"
            @click="editUploaded(row.uid)"
            >upload</el-button
          >
        </el-col>
        <el-col>
          <el-button
            :icon="Edit"
            type="primary"
            size="small"
            v-if="!isEdit(row.uid)"
            @click="edit(row.uid)"
            >Edit</el-button
          >
        </el-col>
      </el-row>
    </template>
  </el-table-column>
</template>

<script setup>
import { isEdit, edit, editUploaded, editCanceled } from "@/lib/admin"
import { Upload, Edit } from "@element-plus/icons-vue"
</script>
